import {
  TelephoneTypeMap,
  DataKindMap,
  ContactKindMap,
  BankAccountTypeMap,
  AddressKindMap,
} from "@customTypes/responses/customer";

export const telephoneTypeDictionary: TelephoneTypeMap = {
  BLANK: "Telefone",
  COMMERCIAL_CELLULAR: "Celular comercial",
  COMMERCIAL_PHONE: "Telefone comercial",
  FAX: "Fax",
  OTHER: "Outro telefone",
  PERSONAL_CELLULAR: "Celular pessoal",
  PERSONAL_PHONE: "Telefone pessoal ",
  WHATSAPP: "Whatsapp",
};

export const addressTypeDictionary: AddressKindMap = {
  BLANK: "Endereço",
  OTHER: "Outro endereço",
  HOME: "Endereço residencial",
  WORK: "Endereço comercial",
};

export const emailTypeDictionary: DataKindMap = {
  BLANK: "E-mail",
  OTHER: "Outro e-mail",
  PERSONAL: "E-mail pessoal",
  WORK: "E-mail comercial",
};

export const subtextMap: ContactKindMap = {
  COMPANY: "Dados da empresa",
  PERSON: "Seus dados",
};

export const documentMap: ContactKindMap = {
  COMPANY: "CNPJ",
  PERSON: "CPF",
};

export const bankAccountTypeMap: BankAccountTypeMap = {
  CHECKING: "Conta corrente",
  SAVING: "Conta poupança",
};
